import comp from "./HideLockedToggle";
export default comp;
